import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import axios from "axios";
import { serializer } from "../../Serializer";
import { useState } from "react";
// import api from "../../api";

const Login = () => {
  const [feed, setFeed] = useState();
  const navigate = useNavigate();
  const defaultValues = {
    username: "",
    password: "",
  };

  const { handleSubmit, register, reset } = useForm({
    defaultValues,
  });

  const onSubmit = (data) => {
    console.log("dadadada", data);
    const formData = new FormData();
    serializer(formData, data);
    api.post("/user/login", data).then((res) => setFeed(res));
    reset();
  };
  useEffect(() => {
    localStorage.setItem("accessToken", feed?.data);
    afterSubmit(feed);
  }, [feed]);

  const afterSubmit = (data) => {
    if (data?.status === 200) {
      return navigate("/admin/home");
    } else return "";
  };

  return (
    <div className="adminForm">
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <label>UserName:</label> <br />
        <input
          {...register("username")}
          type="text"
          placeholder="eg: john"
        />{" "}
        <br />
        <label>Password:</label> <br />
        <input
          type="password"
          {...register("password")}
          placeholder="password"
        />{" "}
        <br />
        <button type="submit"> Login</button>
      </form>
    </div>
  );
};

export default Login;
